

















import type { Currency } from '@getaccept/lib-shared/src/types/Currency';
import type { PropType } from '@vue/composition-api';
import { defineComponent, toRefs, watch } from '@vue/composition-api';
import { DocumentStatsType } from '../../api/types/document-stats-type';
import { DashboardWidgetHeaderColor } from '../../../types/enums/dashboard-widget-header-color';
import { DashboardWidgetValueColor } from '../../../types/enums/dashboard-widget-value-color';
import DashboardWidget from '../../../components/DashboardWidget.vue';
import { useWidgetStore } from '../store/widget.store';
import { useLoadDocumentStats } from '../composables/load-document-stats.composable';

export default defineComponent({
  name: 'WonDealsWidget',
  components: {
    DashboardWidget,
  },
  props: {
    currency: {
      type: Object as PropType<Currency>,
      required: true,
    },
    showAll: {
      type: Boolean,
    },
  },
  setup(props) {
    const { showAll, currency } = toRefs(props);
    const {
      isLoading,
      isSuccess,
      documentCount,
      formattedValue,
      title,
      data,
    } = useLoadDocumentStats(DocumentStatsType.Won, showAll, currency);

    const widgetStore = useWidgetStore();

    watch(data, () => {
      if (!data.value) {
        return;
      }
      widgetStore.setWonValue(data.value.value);
    });

    return {
      title,
      formattedValue,
      DashboardWidgetHeaderColor,
      DashboardWidgetValueColor,
      isLoading,
      isSuccess,
      documentCount,
    };
  },
});
